// Generated by ReScript, PLEASE EDIT WITH CARE


var unleashFeatures = [
  "DeveloperArcadeGames",
  "DeveloperTestingIpad",
  "FeatBadges",
  "FeatBuildTrophyCache",
  "FeatDynamicAvatarIds",
  "FeatSocial",
  "FeatStudentProfile",
  "FeatSxWordmaniaDisable",
  "StudentCanUseLibrary",
  "ProductStudentHasLiteracyCheck",
  "StudentHasStoryverse",
  "StudentHasArcade",
  "StudentHasLocking",
  "StudentHasSecondary",
  "ProductTeacherHasLiteracyCheck"
];

function stringToFlag(x) {
  switch (x) {
    case "AuthFullAccess" :
        return "AuthFullAccess";
    case "AuthProAccess" :
        return "AuthProAccess";
    case "AuthStarterAccess" :
        return "AuthStarterAccess";
    case "CanAccessAx" :
        return "CanAccessAx";
    case "CanAccessAxReports" :
        return "CanAccessAxReports";
    case "CanAccessWordMania" :
        return "CanAccessWordMania";
    case "DeveloperArcadeGames" :
        return "DeveloperArcadeGames";
    case "DeveloperTestingIpad" :
        return "DeveloperTestingIpad";
    case "DeveloperTestingLayouts" :
        return "DeveloperTestingLayouts";
    case "DeveloperTestingLocales" :
        return "DeveloperTestingLocales";
    case "FeatBuildTrophyCache" :
        return "FeatBuildTrophyCache";
    case "FeatDynamicAvatarIds" :
        return "FeatDynamicAvatarIds";
    case "FeatSocial" :
        return "FeatSocial";
    case "FeatStudentProfile" :
        return "FeatStudentProfile";
    case "FeatSxWordmaniaDisable" :
        return "FeatSxWordmaniaDisable";
    case "HomeProduct" :
        return "HomeProduct";
    case "InTrial" :
        return "InTrial";
    case "IsAdmin" :
        return "IsAdmin";
    case "IsDeveloper" :
        return "IsDeveloper";
    case "IsParent" :
        return "IsParent";
    case "IsPlg" :
        return "IsPlg";
    case "LibraryProduct" :
        return "LibraryProduct";
    case "PLGProduct" :
        return "PLGProduct";
    case "ProductStudentHasLiteracyCheck" :
        return "ProductStudentHasLiteracyCheck";
    case "ProductTeacherHasLiteracyCheck" :
        return "ProductTeacherHasLiteracyCheck";
    case "SchoolProduct" :
        return "SchoolProduct";
    case "SchoolProductTrial" :
        return "SchoolProductTrial";
    case "StudentCanAccessWM" :
        return "StudentCanAccessWM";
    case "StudentCanUseLibrary" :
        return "StudentCanUseLibrary";
    case "StudentHasArcade" :
        return "StudentHasArcade";
    case "StudentHasJourneyIntro" :
        return "StudentHasJourneyIntro";
    case "StudentHasLocking" :
        return "StudentHasLocking";
    case "StudentHasPrimaryUx" :
        return "StudentHasPrimaryUx";
    case "StudentHasSecondary" :
        return "StudentHasSecondary";
    case "StudentHasStoryverse" :
        return "StudentHasStoryverse";
    case "StudentIsStudentMode" :
        return "StudentIsStudentMode";
    case "TeacherCanManageTeachingGroups" :
        return "TeacherCanManageTeachingGroups";
    case "TeacherProduct" :
        return "TeacherProduct";
    case "TeacherProductProAccess" :
        return "TeacherProductProAccess";
    case "TeacherProductProTrial" :
        return "TeacherProductProTrial";
    case "TeacherProductStarterAccess" :
        return "TeacherProductStarterAccess";
    case "TrialAvailable" :
        return "TrialAvailable";
    default:
      if (x.indexOf("classic") === 0) {
        return {
                NAME: "Classic",
                VAL: x
              };
      } else {
        return {
                NAME: "Unleash",
                VAL: x
              };
      }
  }
}

function unleashFeatureToString(x) {
  if (typeof x === "object") {
    return x.VAL;
  } else if (x === "DeveloperTestingIpad") {
    return "DeveloperTestingIpad";
  } else if (x === "FeatBadges") {
    return "FeatBadges";
  } else if (x === "StudentHasArcade") {
    return "StudentHasArcade";
  } else if (x === "ProductStudentHasLiteracyCheck") {
    return "ProductStudentHasLiteracyCheck";
  } else if (x === "StudentHasSecondary") {
    return "StudentHasSecondary";
  } else if (x === "ProductTeacherHasLiteracyCheck") {
    return "ProductTeacherHasLiteracyCheck";
  } else if (x === "DeveloperTestingLocales") {
    return "DeveloperTestingLocales";
  } else if (x === "FeatStudentProfile") {
    return "FeatStudentProfile";
  } else if (x === "DeveloperTestingLayouts") {
    return "DeveloperTestingLayouts";
  } else if (x === "FeatSxWordmaniaDisable") {
    return "FeatSxWordmaniaDisable";
  } else if (x === "StudentHasJourneyIntro") {
    return "StudentHasJourneyIntro";
  } else if (x === "StudentHasStoryverse") {
    return "StudentHasStoryverse";
  } else if (x === "StudentCanUseLibrary") {
    return "StudentCanUseLibrary";
  } else if (x === "FeatDynamicAvatarIds") {
    return "FeatDynamicAvatarIds";
  } else if (x === "FeatSocial") {
    return "FeatSocial";
  } else if (x === "FeatBuildTrophyCache") {
    return "FeatBuildTrophyCache";
  } else if (x === "StudentHasLocking") {
    return "StudentHasLocking";
  } else {
    return "DeveloperArcadeGames";
  }
}

export {
  unleashFeatures ,
  stringToFlag ,
  unleashFeatureToString ,
}
/* No side effect */
